import { useCallback } from 'react';

import { useMenuContext } from 'pages/ParentHelper/components/History/hooks/useMenuContext';
import { useParentHelperContext } from 'pages/ParentHelper/providers/ParentHelperProvider/hooks';
import { useSnackbarContext } from 'pages/ParentHelper/providers/SnackbarProvider/hooks';

import type { SnackbarCloseReason } from '@mui/material';
import type { SyntheticEvent } from 'react';

export const useDeleteChat = () => {
  const { onClose: onCloseSnackbar } = useSnackbarContext();
  const { onClose: onCloseMenu, anchorEl } = useMenuContext();
  const { deleteChat, deletedChatId } = useParentHelperContext();

  return useCallback(
    (e: SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
      if (!reason || reason === 'timeout') {
        deleteChat();
        onCloseSnackbar(e);

        if (deletedChatId === anchorEl?.id) {
          onCloseMenu();
        }
      }
    },
    [deleteChat, onCloseSnackbar, onCloseMenu, deletedChatId, anchorEl?.id],
  );
};
